'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeForwardArrowEvent = composeForwardArrowEvent;
exports.composeBackwardArrowEvent = composeBackwardArrowEvent;
exports.composeDotEvent = composeDotEvent;
exports.composeAllResultsEvent = composeAllResultsEvent;
exports.composeTitleEvent = composeTitleEvent;
exports.composeCoverArtEvent = composeCoverArtEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    LABELS = _constantsAnalytics2.default.LABELS;


function composeCarouselEvent(eventAction, eventLabel, eventContainerName) {
  return (0, _compose.composeEvent)(EVENTS.CAROUSEL_INTERACTION, {
    gtmCategory: CATEGORIES.CAROUSELS,
    gtmAction: eventAction,
    gtmLabel: eventLabel,
    gtmValue: 1,
    gtmContainerName: eventContainerName
  });
}

function composeForwardArrowEvent(containerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(ACTIONS.INTERACT_WITH_CONTAINER, LABELS.CONTAINER_FWD_ARROW, containerName)]);
}

function composeBackwardArrowEvent(containerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(ACTIONS.INTERACT_WITH_CONTAINER, LABELS.CONTAINER_BWD_ARROW, containerName)]);
}

function composeDotEvent(containerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(ACTIONS.INTERACT_WITH_CONTAINER, LABELS.CONTAINER_DOT_INDICATORS, containerName)]);
}

function composeAllResultsEvent(containerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(ACTIONS.INTERACT_WITH_CONTAINER, LABELS.CONTAINER_VIEW_ALL, containerName)]);
}

function composeTitleEvent(containerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(ACTIONS.INTERACT_WITH_CONTAINER, LABELS.CONTAINER_TITLE, containerName)]);
}

function composeCoverArtEvent(containerName) {
  return (0, _compose.composeAnalytics)([composeCarouselEvent(ACTIONS.CLICK_IMAGE, LABELS.BIB_IMAGE, containerName)]);
}

exports.default = {
  EVENTS: EVENTS,
  ACTIONS: ACTIONS,
  CATEGORIES: CATEGORIES,
  LABELS: LABELS,
  composeForwardArrowEvent: composeForwardArrowEvent,
  composeBackwardArrowEvent: composeBackwardArrowEvent,
  composeDotEvent: composeDotEvent,
  composeAllResultsEvent: composeAllResultsEvent,
  composeTitleEvent: composeTitleEvent,
  composeCoverArtEvent: composeCoverArtEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/carouselEventComposer.js
// module id = 550
// module chunks = 0 2 4 6 7 8 9 10